import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { environment } from '../../environments/environment';
import { UserInfo } from '../models/user-info.model';

/**
 * Encapsulates user related operations.
 */
@Injectable({
  providedIn: 'root',
})
export class UserService {
  /**
   * Creates an instance of service.
   * 
   * @param http HTTP request/response handler.
   */
  constructor(private http: HttpClient) { }

  /**
   * API base URL for data users related HTTP requests.
   */
  private baseUrl = `${environment.datalabUrl}users`;

  /**
   * Search users by name.
   * 
   * @param name User name (can be partial).
   * @returns List of users.
   */
  search(name: string): Observable<User[]> {
    let params = new HttpParams();
    params = params.set('name', name);

    return this.http.get<User[]>(`${this.baseUrl}/search`, { params });
  }

  /**
   * User login callback.
   * 
   * @returns 204 No Content
   */
  login(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('x-skip-error-handler', 'true');

    return this.http.post<any>(`${this.baseUrl}/login`, null, { headers });
  }

  /**
   * Get current user information.
   * 
   * @returns Current user information.
   */
  me(): Observable<UserInfo> {
    let headers = new HttpHeaders();
    headers = headers.set('x-skip-error-handler', 'true');

    return this.http.get<UserInfo>(`${this.baseUrl}/me`, { headers });
  }
}
